import React from "react";
import AnswerList from "components/AnswerList";

import { config } from "./config";

export default function LocalLegalActs() {
  return <AnswerList config={config} />;
}
